import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'price'})
export class PricePipe implements PipeTransform {

  public transform(value: number, args?: string[]): string {
    if (!value) {
      return '0 €';
    }

    let rounded = Number(Math.round(value * 100) / 100).toFixed(2);
    return `${rounded} €`;
  }

}
